// shared/agreements.ts: the two agreements a builder accepts before paying (docs/SPEC.md 16.10). The texts are
// config/agreements/<id>.md (the app shows them in a side panel); each carries its version in a "Version:" line, which a
// test keeps equal to the one here. Changing a document's terms means a new version here and in its file. An acceptance
// records the versions accepted (billing_agreements, migrations/0015_agreements.sql).

export type AgreementId = "service" | "dpa";
export type Agreement = { id: AgreementId; title: string; version: string };

export const AGREEMENTS: readonly Agreement[] = [
  { id: "service", title: "Service Agreement", version: "2026-10-23" },
  { id: "dpa", title: "Data Processing Agreement", version: "2026-10-23" },
];

/** The versions a checkbox accepts, as the subscribe and go-live requests carry them. */
export type AgreementAcceptance = { service: string; dpa: string };

/** The current versions, for the request body. */
export function currentAcceptance(): AgreementAcceptance {
  const v = (id: AgreementId) => AGREEMENTS.find((a) => a.id === id)!.version;
  return { service: v("service"), dpa: v("dpa") };
}
